"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeDiffAll = exports.timeDiff = void 0;
/**
 * TODO keep? If we want to just return the biggest unit we could use the other function and take the first element
 *  Also this is still subtly wrong, because it also takes the floor of negative diffs, i.e. in 1 minute, but 2 minutes ago if the parameters are switched
 *
 * Return the time difference in a format usable by Intl.RelativeTimeFormat
 * @param date
 * @param reference
 */
function timeDiff(date, reference) {
    var referenceOrNow = reference ? reference.getTime() : Date.now();
    var diff = (referenceOrNow - date.getTime()) / 1000;
    if (Math.abs(diff) < 60) {
        var secs = Math.floor(diff);
        return { value: -1 * secs, unit: 'second' };
    }
    else if (Math.abs(diff) < 60 * 60) {
        var mins = Math.floor(diff / 60);
        return { value: -1 * mins, unit: 'minute' };
    }
    else if (Math.abs(diff) < 60 * 60 * 24) {
        var hour = Math.floor(diff / 60 / 60);
        return { value: -1 * hour, unit: 'hour' };
    }
    else if (Math.abs(diff) < 60 * 60 * 24 * 7) {
        var days = Math.floor(diff / 60 / 60 / 24);
        return { value: -1 * days, unit: 'day' };
    }
    else {
        var weeks = Math.floor(diff / 60 / 60 / 24 / 7);
        return { value: -1 * weeks, unit: 'week' };
    }
}
exports.timeDiff = timeDiff;
/**
 * Return the complete time difference split by units, Order descending (weeks,days,...) and leaving out units with value 0.
 *
 * @param date
 * @param reference
 * @returns Example [[1,{"style":"unit","unit":"minute"}],[41,{"style":"unit","unit":"second"}]]
 */
function timeDiffAll(date, reference) {
    var referenceOrNow = reference ? reference.getTime() : Date.now();
    var diff = (referenceOrNow - date.getTime()) / 1000;
    var sign = Math.sign(diff);
    diff = Math.abs(diff);
    var formatList = [];
    if (diff > 60 * 60 * 24 * 7) {
        var weeks = Math.floor(diff / 60 / 60 / 24 / 7);
        diff = diff - weeks * (60 * 60 * 24 * 7);
        formatList = __spreadArray(__spreadArray([], formatList, true), [[weeks, { style: 'unit', unit: 'week' }]], false);
    }
    if (diff > 60 * 60 * 24) {
        var days = Math.floor(diff / 60 / 60 / 24);
        diff = diff - days * (60 * 60 * 24);
        formatList = __spreadArray(__spreadArray([], formatList, true), [[days, { style: 'unit', unit: 'day' }]], false);
    }
    if (diff > 60 * 60) {
        var hour = Math.floor(diff / 60 / 60);
        diff = diff - hour * (60 * 60);
        formatList = __spreadArray(__spreadArray([], formatList, true), [[hour, { style: 'unit', unit: 'hour' }]], false);
    }
    if (diff > 60) {
        var mins = Math.floor(diff / 60);
        diff = diff - mins * 60;
        formatList = __spreadArray(__spreadArray([], formatList, true), [[mins, { style: 'unit', unit: 'minute' }]], false);
    }
    var secs = Math.floor(diff);
    formatList = __spreadArray(__spreadArray([], formatList, true), [[secs, { style: 'unit', unit: 'second' }]], false);
    // TODO what to do with the sign? -1 could mean "ago", and +1 could mean "in"
    // return formatList.map(([value, options]) => [sign * value, options]);
    return formatList;
}
exports.timeDiffAll = timeDiffAll;
//# sourceMappingURL=time.js.map